import React from 'react';
import { Link } from 'react-router-dom';
export const Footer = () => {
  return <footer className="w-full py-12 px-6 md:px-12 bg-gray-50 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700" data-id="element-61">
      <div className="max-w-6xl mx-auto" data-id="element-62">
        <div className="flex flex-col items-center text-center" data-id="element-63">
          <div className="mb-6" data-id="element-64">
            <Link to="/" className="flex items-center justify-center" data-id="element-65">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pLF1xF3x24A3EHrkGHQH5h/RH_Logo%2C_No_Text.png" alt="RootHealth Logo" className="h-10 mr-2" data-id="element-66" />
              <span className="text-xl font-bold text-charcoal-700 dark:text-gray-100" data-id="element-67">
                RootHealth
              </span>
            </Link>
          </div>
          <p className="text-gray-600 dark:text-gray-300 max-w-2xl mb-6" data-id="element-68">
            RootHealth helps hospitals achieve and maintain CMS price
            transparency compliance in under 30 days—affordably and with a
            compliance guarantee.
          </p>
          <div className="pt-6 border-t border-gray-200 dark:border-gray-700 w-full text-center" data-id="element-69">
            <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-70">
              © {new Date().getFullYear()} RootHealth. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>;
};